export default {
  "1": {
    id: 1,
    answer: "a",
  },
  "2": {
    id: 2,
    answer: "c",
  },
  "3": {
    id: 3,
    answer: "a",
  },
  "4": {
    id: 4,
    answer: "c",
  },
  "5": {
    id: 5,
    answer: "a",
  },
  "6": {
    id: 6,
    answer: "b",
  },
  "7": {
    id: 7,
    answer: "b",
  },
  "8": {
    id: 8,
    answer: "b",
  },
  "9": {
    id: 9,
    answer: "a",
  },
  "10": {
    id: 10,
    answer: "c",
  },
  "11": {
    id: 11,
    answer: "d",
  },
  "12": {
    id: 12,
    answer: "a",
  },
  "13": {
    id: 13,
    answer: "b",
  },
  "14": {
    id: 14,
    answer: "b",
  },
  "15": {
    id: 15,
    answer: "b",
  },
  "16": {
    id: 16,
    answer: "b",
  },
  "17": {
    id: 17,
    answer: "b",
  },
  "18": {
    id: 18,
    answer: "b",
  },
  "19": {
    id: 19,
    answer: "a",
  },
  "20": {
    id: 20,
    answer: "c",
  },
  "21": {
    id: 21,
    answer: "c",
  },
  "22": {
    id: 22,
    answer: "a",
  },
  "23": {
    id: 23,
    answer: "b",
  },
};
